import styled from '@emotion/styled'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useResponsive } from 'hooks/useResponsive'
import { ReactNode } from 'react'

const Header = styled(TableCell)`
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 16px;
  letter-spacing: 0.4;
`

interface Props {
  headers: (ReactNode | string)[]
  rows: ReactNode[][]
  responsive?: ReactNode[] | ReactNode
}

const CoreTable = ({ headers, rows, responsive }: Props) => {
  const { isTablet } = useResponsive()
  if (isTablet && responsive) {
    return <>{responsive}</>
  } else {
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header, idx) => (
                <Header align={idx === 0 ? 'left' : 'center'} key={idx}>
                  {header}
                </Header>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((_row, _idx) => (
              <TableRow key={_idx}>
                {_row.map((r, i) => (
                  <TableCell
                    key={i}
                    align="center"
                    size={i === _row.length - 1 ? 'small' : 'medium'}
                  >
                    {r}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }
}

export default CoreTable
